import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip, Button, CardTitle } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/riwayatjabatanService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";

import moment from "moment";
import Shimmer from "react-shimmer-effect";
class TableSecondaryComponent extends Component {
  dataTableBloc = new DataTableBloc();

  currentRoleId = JSON.parse(localStorage.getItem("currentRoleId"));

  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_uuid
    : "";

  source;
  historyTable = "historyriwayatangkakreditJabfung";
  defaultOrder = "credit_number_create_date";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  modal_confirm_status = 0;
  modal_confirm_message = "";
  modal_confirm_sucess_message = "data berhasil di Sinkronisasikan";
  modal_confirm_error_message = "data gagal di Sinkronisasikan";

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      downloadUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      totalAK : 0,
      loadingTable: true,
      position_name : this.props.position_name_new,//JSON.parse(localStorage.getItem("userdata")).employee_current_position_name,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },

      runType: 0,
      confirmInfo: "",
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      uuid: this.peg_uuid,
    };
    await this.dataTableBloc.fetchJabfungTable(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  // confirmResponse = (response) => {
  //   let forState = {};
  //   switch (response) {
  //     case "cancel":
  //       forState = {
  //         confirm: false,
  //       };
  //       break;
  //     case "confirm":
  //       forState = {
  //         loading: true,
  //         confirm: false,
  //       };
  //       let data_status = parseInt(this.modal_confirm_status);
  //       if (data_status === 1) {
  //         this.inactiveData();
  //       } else {
  //         this.activeData();
  //       }
  //       break;
  //     case "success":
  //       forState = {
  //         success: false,
  //         redirect: true,
  //       };
  //       break;
  //     case "failed":
  //       forState = {
  //         failed: false,
  //       };
  //       break;
  //     default:
  //   }
  //   this.setState(forState);
  // };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  activeData = async () => {
    await this.dataTableBloc.fetchActive({ uuid: this.state.inactiveUuid });
  };

  SyncronizeButton = () => {
    this.setState({
      confirm: true,
      runType: 1,
      confirmInfo:
        "Apakah anda yakin akan melakukan penarikan data Riwayat Angka Kredit PKPM ?",
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };

        if (this.state.runType == 1) {
          this.dataTableBloc.SyncronizeJabfung();
        }

        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
          showUpload: false,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.jabfungrowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          let totalAK = response.result.reduce((sum, item) => {
            if (item.credit_number_is_promoted != 1) {
              return sum + (
                parseFloat(item.credit_number_value)
              );
            }
            return sum;
          }, 0);  
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
            totalAK : totalAK
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.SyncronizeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          // const link = result.data.response;
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          this.setTokenAPI();
          break;
        case apiResponse.ERROR:
          this.setState({
            // urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.jabfungrowtableChannel?.unsubscribe();
    // this.dataTableBloc.SyncronizeChannel?.unsubscribe();
  }

  columns = [
    {
      key: "credit_number_create_date",
      text: "Tanggal Pengajuan",
      className: "credit_number_create_date",
      sortable: true,
      width: "20%",
    },

    {
      key: "credit_number_year",
      text: "Tahun Angka Kredit",
      className: "credit_number_year",
      sortable: true,
      width: "20%",
    },

    {
      key: "level_name",
      text: "Level JF",
      className: "level_name",
      sortable: true,
      width: "20%",
    },

    {
      key: "credit_number_periode_name",
      text: "Periode",
      className: "credit_number_periode_name",
      sortable: true,
      width: "20%",
    },

    {
      key: "credit_number_month_name",
      text: "Bulan",
      className: "credit_number_month_name",
      sortable: true,
      width: "20%",
    },
    {
      key: "level_predicate_name",
      text: "Predikat",
      className: "level_predicate_name",
      sortable: true,
      width: "20%",
    },
    {
      key: "credit_number_value",
      text: "Angka Kredit",
      className: "credit_number_value",
      sortable: true,
      width: "30%",
      cell: (record) => {
        const isPromoted = record.credit_number_is_promoted !== null;

        return (
          <span>
            <label>
              <>
                <div
                  className={`rounded-circle d-inline-block ${
                    isPromoted ? "bg-danger" : "bg-success"
                  }`}
                  style={{
                    width: 12,
                    height: 12,
                    marginRight: 6,
                    verticalAlign: "middle",
                  }}
                />
                {parseFloat(record.credit_number_value)}
              </>
            </label>
          </span>
        );
      },
    },
    {
      key: "credit_number_approve_date",
      text: "Tanggal Menyetujui",
      className: "credit_number_approve_date",
      sortable: true,
      width: "20%",
    },
    {
      key: "download",
      text: "File",
      className: "download",
      width: "20%",
      cell: (record) => {
        const thisId = record.credit_number_uuid;
        const file = record.credit_number_file;

        return file ? (
          <Fragment>
            <span>
              <a
                href={file}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary btn-sm"
                id={"download-" + thisId}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="fas fa-download"></i>
              </a>
              <Tooltip
                style={{ marginBottom: 2 }}
                placement="top"
                isOpen={this.state["download" + thisId]}
                target={"download-" + thisId}
                toggle={() => {
                  this.setState({
                    ["download" + thisId]: !this.state["download" + thisId],
                  });
                }}
              >
                Download
              </Tooltip>
            </span>
          </Fragment>
        ) : (
          <span className="text-muted">Tidak ada file</span>
        );
      },
    },

    // cell: (record) =>
    //   record.credit_number_file ? (
    //     <a
    //       href={record.credit_number_file}
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       <button className="btn btn-primary btn-sm">
    //         <i className="fas fa-download"></i> Download
    //       </button>
    //     </a>
    //   ) : (
    //     <span className="text-muted">Tidak ada file</span>
    //   ),

    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.credit_number_uuid;
        return (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.credit_number_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-align-left"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detil
              </Tooltip>
            </span>
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        {this.currentRoleId == 1 && (
          <div className="float-end">
            {
              <Button
                color="danger"
                onClick={() => {
                  this.SyncronizeButton();
                }}
              >
                Sinkronisasi
              </Button>
            }
          </div>
        )}
        <CardTitle>Daftar Riwayat Angka Kredit PKPM</CardTitle>
        <div className="col-md-6">
          <div className="d-flex gap-4 shadow rounded p-3">
              <div>
                  <p style={{fontSize:"14px", fontWeight:"400", color:"#252525"}}>Jabatan Saat ini</p>
                  <p className="m-0" style={{fontSize:"14px", fontWeight:"600", color:"#252525"}}>
                    {
                      this.state.loadingTable ?
                      <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                      </Shimmer>
                      :
                      this.state.position_name || '-'
                    }
                  </p>
              </div>
              <div>
                  <p style={{fontSize:"14px", fontWeight:"400", color:"#252525"}}>Akumulasi Angka Kredit</p>
                  <p className="m-0" style={{fontSize:"14px", fontWeight:"600", color:"#252525"}}>
                    {
                      this.state.loadingTable ?
                      <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                      </Shimmer>
                      :
                      this.state.totalAK
                    }
                  </p>
              </div>
          </div>
        </div>
        <div className="p-2 bd-highlight float-end">
            <div style={{ paddingTop: 8 }}>
              <div
                className="bg-success rounded-circle d-inline-block"
                style={{ width: 12, height: 12, marginRight: 6, verticalAlign: "middle" }}
              ></div>
              Angka Kredit Baru 
            </div>
          </div>

          <div className="p-2 bd-highlight float-end">
            <div style={{ paddingTop: 8 }}>
              <div
                className="bg-danger rounded-circle d-inline-block"
                style={{ width: 12, height: 12, marginRight: 6, verticalAlign: "middle" }}
              ></div>
              Angka Kredit Lama
            </div>
          </div>
          <br/><br/>
        <hr />

        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={this.state.confirmInfo}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo={this.modal_confirm_sucess_message}
          failedTitle="Gagal!"
          failedInfo={this.modal_confirm_error_message}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/home.html?riwayat_angkakredit&detailjabfung&uuid=" +
              this.state.detailUuid
            }
          />
        ) : null}
      </>
    );
  }
}

export default TableSecondaryComponent;
